var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17753 1.25H9.75C10.7165 1.25 11.5 2.0335 11.5 3V10.25C11.5 11.2165 10.7165 12 9.75 12H2.75C1.7835 12 1 11.2165 1 10.25V3C1 2.0335 1.7835 1.25 2.75 1.25H3.32247C3.53761 0.527128 4.20724 0 5 0H7.5C8.29276 0 8.96239 0.527128 9.17753 1.25ZM3.41841 2.75H2.75C2.61193 2.75 2.5 2.86193 2.5 3V10.25C2.5 10.3881 2.61193 10.5 2.75 10.5H9.75C9.88807 10.5 10 10.3881 10 10.25V3C10 2.86193 9.88807 2.75 9.75 2.75H9.08159C8.80073 3.34124 8.1981 3.75 7.5 3.75H5C4.3019 3.75 3.69927 3.34124 3.41841 2.75ZM4.75 1.75C4.75 1.61193 4.86193 1.5 5 1.5H7.5C7.63807 1.5 7.75 1.61193 7.75 1.75V2C7.75 2.13807 7.63807 2.25 7.5 2.25H5C4.86193 2.25 4.75 2.13807 4.75 2V1.75Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.48999C3.5 5.07578 3.83579 4.73999 4.25 4.73999H8.25C8.66421 4.73999 9 5.07578 9 5.48999C9 5.9042 8.66421 6.23999 8.25 6.23999H4.25C3.83579 6.23999 3.5 5.9042 3.5 5.48999Z",
    fill: "#5062F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.46997C3.5 8.05576 3.83579 7.71997 4.25 7.71997H8.25C8.66421 7.71997 9 8.05576 9 8.46997C9 8.88418 8.66421 9.21997 8.25 9.21997H4.25C3.83579 9.21997 3.5 8.88418 3.5 8.46997Z",
    fill: "#5062F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuotes);
export default __webpack_public_path__ + "static/media/requestQuotes.5f115491eeb70ca617e2c06edb6fc3b6.svg";
export { ForwardRef as ReactComponent };